/**
 * Composes the opt-in order document extension into Create Document menu + modals.
 * @see docs/OPT_IN_ORDER_DOCUMENTS.md
 */

import { useOptInOrderDocumentExtension } from "./opt-in-order-document-extension";
import type { OrderMenuDocumentExtensionContext } from "./types";

export const useOrderMenuDocumentExtensions = (ctx: OrderMenuDocumentExtensionContext) => useOptInOrderDocumentExtension(ctx);
